import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      index: 0
    }
  },
  {
    path: '/tklist',
    name: 'tklist',
    // route level code-splitting
    // this generates a separate chunk (tklist.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "tklist" */ '../views/TkList.vue'),
    meta: {
      index: 1
    }
  },
  {
    path: '/tkdetail',
    name: 'tkdetail',
    // route level code-splitting
    // this generates a separate chunk (tkdetail.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "tkdetail" */ '../views/TkDetail.vue'),
    meta: {
      index: 2
    }
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router
